<template>
  <div
    class="homepage-logo-banner bg-neutral-white relative flex w-full flex-col items-center justify-center gap-2"
  >
    <div
      class="banner-logo-wrapper bg-neutral-white absolute left-0 right-0 top-1/2 -translate-y-1/2 transition-opacity duration-300 landscape:group-hover:hidden"
    >
      <slot name="banner-logo" />
    </div>
    <div
      class="banner-text-wrapper pointer-events-auto -z-[1] items-center justify-center group-focus-within:z-[0] group-hover:z-[0]"
    >
      <slot name="banner-text" />
    </div>
  </div>
</template>
